
<script>
import { mapGetters } from 'vuex'

import moment from 'moment'
import {
  nToWord,
  formatPriceWithSign
} from '@/utils/helpers'
import starIcon from '@/assets/images/icons/star.svg?inline'
import locationIcon from '@/assets/images/icons/location.svg?inline'
import editIcon from '@/assets/images/icons/pencil.svg?inline'

export default {
  name: 'sale-cards',
  components: {
    starIcon,
    locationIcon,
    editIcon
  },
  computed: {
    collection() {
      return this.$store.getters['sale/getCollection']
    },
    ...mapGetters('account', [
      'checkEditSaleAccess'
    ])
  },
  methods: {
    openEditForm(id) {
      this.$store.commit('sale/updateModalForm', {
        active: true,
        mode: 'edit'
      })

      this.$store.commit('sale/setEditableNowSaleId', id)
      this.$store.commit('sale/updateIsModalFormLoading', true)
      this.$store.dispatch('sale/getSale', id)
    },
    formatDate: date => moment.unix(date).format('DD.MM.YYYY'),
    durationFormat: duration => `${duration} ${nToWord(duration, ['ночь', 'ночи', 'ночей'])}`,
    formatPrice({ amount, currency }) {
      const dictionary = this.$store.getters.getDictionary('sale.dictionaries.currencies')

      return formatPriceWithSign(amount, currency, dictionary)
    },
    routerParams({
      isHotel,
      id,
      name,
      redirectInfo
    }) {
      const {
        rooms,
        duration,
        checkInDate,
        currency,
        placeId
      } = redirectInfo

      const params = {
        name: isHotel
          ? 'Cart'
          : 'HotelsSearch',
        params: {
          id: isHotel
            ? redirectInfo.placeId
            : null,
          service: 'hotels',
        },
        query: {
          saleId: id,
          placeId,
          checkInDate: this.formatDate(checkInDate),
          duration,
          rooms,
          currency,
        }
      }

      if (!isHotel) {
        const {
          placeType,
          hotelSearchId,
          hasMore
        } = redirectInfo

        params.query = {
          ...params.query,
          placeType,
          placeName: name,
          service: 'hotel',
          hasMore,
          hotelSearchId
        }
      }

      return params
    }
  }
}
</script>
<template>
  <div class="sale-cards">
    <div
      v-for="sale in collection"
      :key="`sale${sale.id}`"
      class="sale-cards__card search-card"
    >
      <div class="search-card__image">
        <img
          v-lazyload
          src="@/assets/images/default.jpg"
          :data-src="sale.imageSrc"
        >
      </div>
      <div class="search-card__content">
        <div class="search-card__content-wrap">
          <div class="sale-cards__card-content">
            <div>
              <h2 class="search-card__title">
                {{ sale.name }}
              </h2>
              <div
                v-if="sale.isHotel"
                class="search-card__stars"
              >
                <starIcon
                  v-for="i in sale.category"
                  :key="`star_${i}`"
                />
              </div>
              <p class="sale-cards__card-text">
                {{ sale.description }}
              </p>
            </div>
            <div class="sale-cards__card-dates">
              <p>Заезд</p>
              <div class="sale-cards__card-dates-wrap">
                <p>{{ formatDate(sale.checkInDate) }}</p>
                <p>{{ durationFormat(sale.duration) }}</p>
              </div>
            </div>
          </div>
          <div class="search-card__content-item search-card__content-item--flex">
            <div>
              <div
                class="sale-cards__card-edit-wrap"
                :class="{
                  'sale-cards__card-edit-wrap--no-rating': !sale.rating
                }"
              >
                <div
                  v-if="sale.rating"
                  class="search-card__rating"
                >
                  {{ `${sale.rating}/100` }}
                </div>
                <edit-icon
                  v-if="checkEditSaleAccess"
                  @click="openEditForm(sale.id)"
                />
              </div>
              <a
                v-if="sale.isHotel"
                :href="`http://www.google.com/maps/place/${sale.latitude},${sale.longitude}`"
                target="_blank"
                class="search-card__location"
              >
                <location-icon />
                <span>{{ sale.city }}</span>
              </a>
              <img
                v-else
                v-lazyload
                src=""
                :data-src="sale.flag"
                class="sale-cards__card-flag"
              >
            </div>
            <div class="search-card__prices">
              <router-link
                :to="routerParams(sale)"
                class="search-card__link"
              >
                <span>
                  {{ `от ${formatPrice(sale.price)}` }}
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>